"use client"
import Image from "next/image"
import CallToAction from "@/components/CallToAction"
import PlusPattern from "../../public/assets/plus-pattern-long.svg"

export default function SupportSection({csmEmail}) {

  return (
    <section id="need-help" className="bg-white text-blue py-10 lg:pt-14 lg:pb-20 overflow-x-hidden">
      <div className="container">
        <div className="grid md:grid-cols-2 gap-9 place-content-center">
          <div className="grid grid-cols-1 gap-4 place-content-center">
            <div>
            <p className="eyebrow uppercase">ONBOARDING SUPPORT</p>
            <h2>Need More Help? We're Here for You</h2>
            </div>
            <p>Contact your Client Success Manager at any time for assistance. We&rsquo;re happy to schedule a personalized support session and walk you through the steps—just be ready to log in and share your screen, and we&rsquo;ll guide you from there.</p>
            <div><CallToAction href={`mailto:${csmEmail}`} style="primary">Request a Session</CallToAction></div>
          </div>
          <div className="relative">
            
            <Image 
              src="/assets/support.png"
              height={316}
              width={495}              
              alt="coworkers"
              className="relative z-10 w-full h-auto"
            />
            <PlusPattern className="absolute w-1/4 h-auto lg:w-auto -top-40 lg:-top-14 -right-4 lg:-right-24 z-0 rounded-[30px]" />

          </div>
        </div>
      </div>
    </section>
  )
}